var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"to":_vm.link
        ? {
            name: 'member-management-deadline-monitoring-deadline-details',
            params: {
              itemId: _vm.deadline.meta.id,
            },
          }
        : null,"outlined":_vm.outlined}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"9"}},[(!_vm.hideTitle)?_c('v-card-title',{staticClass:"subheading"},[_vm._v(" "+_vm._s(_vm.deadline.title)+" ")]):_vm._e(),_c('v-card-text',[_c('v-row',{staticClass:"match-height",attrs:{"dense":""}},_vm._l((_vm.deadline.watchers),function(watcher,index){return _c('v-col',{key:index,attrs:{"cols":"sm"}},[_c('v-card',{staticClass:"pa-2",attrs:{"color":`${_vm.getMaterialColor(watcher.color, {
                  input: 'hex',
                  output: 'word',
                })} lighten-4`,"dark":"","disabled":watcher.value == 0,"outlined":""}},[_c('div',{class:[
                    'font-weight-medium text-h5 text-center text--darken-4',
                    `${_vm.getMaterialColor(watcher.color, {
                      input: 'hex',
                      output: 'word',
                    })}--text`,
                  ]},[_vm._v(" "+_vm._s(watcher.value)+" ")]),_c('div',{class:[
                    'font-weight-medium subtitle-2 text-center text--darken-4',
                    `${_vm.getMaterialColor(watcher.color, {
                      input: 'hex',
                      output: 'word',
                    })}--text`,
                  ]},[_vm._v(" "+_vm._s(watcher.title)+" ")])])],1)}),1)],1)],1),_c('v-divider',{attrs:{"vertical":""}}),_c('v-col',{staticClass:"d-flex justify-center align-center",attrs:{"cols":"3"}},[_c('VueApexCharts',{staticClass:"mx-2 px-2",attrs:{"type":"donut","options":_vm.timeSpendingChartConfig,"series":_vm.timeSpendingChartSeries,"height":"95px"}})],1)],1),(_vm.showDeadlineDistribution)?_c('v-divider'):_vm._e(),(_vm.showDeadlineDistribution)?_c('VueApexCharts',{staticClass:"mx-2 px-2 py-3",attrs:{"type":"heatmap","options":_vm.heatmapChartConfig,"series":_vm.heatmapChartSeries,"height":300}}):_vm._e(),(_vm.showActions)?_c('v-divider'):_vm._e(),(_vm.showActions)?_c('v-card-actions',{staticClass:"mx-2"},[_c('v-btn',{attrs:{"depressed":"","outlined":"","text":"","to":{
          name: 'member-management-deadline-monitoring-deadline-bulk-input',
          params: {
            organizationId: _vm.$route.params.organizationId,
            itemId: _vm.deadline.meta.id,
          },
        }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-form-textbox")]),_vm._v("Sammeleingabe")],1),_c('v-btn',{attrs:{"depressed":"","outlined":"","text":"","to":{
          name: 'member-management-deadline-monitoring-deadline-edit',
          params: {
            organizationId: _vm.$route.params.organizationId,
            itemId: _vm.deadline.meta.id,
          },
        }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-pencil")]),_vm._v("Bearbeiten")],1),_c('v-spacer'),_c('v-btn',{attrs:{"depressed":"","outlined":"","text":"","to":{
          name: 'member-management-deadline-monitoring-deadline-details',
          params: {
            organizationId: _vm.$route.params.organizationId,
            itemId: _vm.deadline.meta.id,
          },
        }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-eye")]),_vm._v("Details")],1)],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }